__turbopack_context__.v({
  "contentContainer": "QSxx1W_contentContainer",
  "contentWrapper": "QSxx1W_contentWrapper",
  "disclaimer": "QSxx1W_disclaimer",
  "imageText": "QSxx1W_imageText",
  "imageWrapper": "QSxx1W_imageWrapper",
  "item": "QSxx1W_item",
  "itemsWrapper": "QSxx1W_itemsWrapper",
  "sectionTitle": "QSxx1W_sectionTitle",
});
